"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pclnDesignSystem = require("pcln-design-system");

var _Caption = _interopRequireDefault(require("../../../text/Caption"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function AmenitiesList(_ref) {
  var className = _ref.className,
      amenities = _ref.amenities;
  return amenities && amenities.length > 0 && _react["default"].createElement(_pclnDesignSystem.Flex, {
    className: className
  }, amenities.map(function (amenity, index) {
    return _react["default"].createElement(_pclnDesignSystem.Flex, {
      key: index,
      mr: 2
    }, _react["default"].createElement(_pclnDesignSystem.Icon, {
      name: amenity.icon,
      size: 18,
      color: "text.light",
      mr: 1
    }), _react["default"].createElement(_Caption["default"], {
      subdued: true
    }, amenity.name));
  }));
}

AmenitiesList.displayName = 'AmenitiesList';
AmenitiesList.propTypes = {
  className: _propTypes["default"].string,
  amenities: _propTypes["default"].array
};
AmenitiesList.defaultProps = {
  className: '',
  amenities: []
};

var _default = (0, _react.memo)(AmenitiesList);

exports["default"] = _default;